// extracted by mini-css-extract-plugin
module.exports = {"title":"editEvent_title__xYd1c"};